<template>
  <div class="LLMetaIconInfo" :class="classList">
    <div class="LLMetaIconInfo__icon-wrapper">
      <slot></slot>
    </div>
    <div class="LLMetaIconInfo__value-text">
      <span class="">{{ value }}</span>
      <span v-if="text && showText" class=""> {{ text }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LLMetaIconInfo',
  props: {
    value: { type: Number, default: 0 },
    text: { type: String, default: '' },
    showText: { type: Boolean, default: true },
    grey: { type: Boolean, default: false },
    primaryIcon: { type: Boolean, default: false }
  },
  computed: {
    classList() {
      return {
        LLMetaIconInfo_grey: this.grey,
        'LLMetaIconInfo_primary-icon': this.primaryIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.LLMetaIconInfo {
  $root: &;
  @apply flex items-center;
  &__icon-wrapper {
    @apply w-6 h-6 flex flex-shrink-0 items-center justify-center text-accent-01-400;
    & > * {
      @apply text-accent-01-400 w-5;
      #{$root}_primary-icon & {
        @apply text-primary-01-400;
      }
    }
    #{$root}_primary-icon & {
      @apply text-primary-01-400;
    }
  }
  &__value-text {
    @apply text-body-02 ml-1;
    height: 1.25rem;

    #{$root}_grey & {
      @apply text-neutral-01-600;
    }
  }
}
</style>
